import axios from 'axios';

const backendURL = 'https://api.sessaodatarde.net/';
const frontendURL = 'https://www.sessaodatarde.net/';

const MercadoPagoAxios = axios.create({
  baseURL: 'https://api.sessaodatarde.net/mercadoPagoAPI'
});

export default {
  MercadoPagoDefaultPreference: {
    "back_urls": {
      "success": frontendURL+"checkout/confirmacao",
      "failure": frontendURL+"checkout/confirmacao",
      "pending": frontendURL+"checkout/confirmacao",
    },
    "payer": {
      name: null,
      surname: null,
      email: null
    },
    "auto_return": "approved",
    "payment_methods": {
      "excluded_payment_methods": [
        {
          "id": "pec"
        }
      ],
    "installments": 1,
    "default_payment_method_id": null,
    "default_installments": null,
    },
    "notification_url": backendURL+"mercadoPagoIPN",
    "expires": true
  },
  get(endpoint , extraParams){
    if ( typeof(extraParams) == 'object' && Object.keys(extraParams).length ){
      Object.keys(extraParams).forEach(key =>{
        MercadoPagoAxios.defaults.params[key] = extraParams[key];
      });
    }
    return MercadoPagoAxios.get(endpoint);
  },
  post(endpoint , payload){
    if ( typeof(payload) == 'object' && Object.keys(payload).length ){
      return MercadoPagoAxios.post(endpoint, payload);
    }
  },
  makePreference(payload){
    return MercadoPagoAxios.post('checkout/preferences', payload);
  }
};
